// Este archivo es generado automáticamente durante el build
export const buildInfo = {
  "version": "v2.1.0",
  "buildDate": "2026-04-14T17:49:36.551Z",
  "buildTime": "14/04/2026, 17:49:36 UTC",
  "buildTimestamp": 1776188976551,
  "gitCommit": "3ad27d061b109523d967f5e2782222128843cf93",
  "gitBranch": "HEAD",
  "environment": "production"
}